export const SET_FILTRO_LISTAGEM_USUARIO_PERFIL_FAZENDA =
    'SET_FILTRO_LISTAGEM_USUARIO_PERFIL_FAZENDA'

export const setFiltroListagem = (filtroListagem) => ({
    type: SET_FILTRO_LISTAGEM_USUARIO_PERFIL_FAZENDA,
    filtroListagem,
})
